import isEmpty from "lodash-es/isEmpty";
import startCase from "lodash-es/startCase";
import type { CSSProperties, ReactNode } from "react";
import { Label } from "@/components/atoms/label";
import { cn } from "@/lib/utils";

export interface FieldViewWrapperProperties {
  id: string;
  label: string;
  errorMessage?: string;
  toHide?: boolean;
  className?: string;
  style?: CSSProperties;
  labelClassName?: string;
  labelUseIdForA11y?: boolean;
  children: ReactNode;
}

const DEFAULT_WRAPPER_CLASS = "w-full mb-4 overflow-visible";

export const FieldViewWrapper = ({
  id,
  label,
  errorMessage,
  toHide = false,
  className,
  style,
  labelClassName,
  labelUseIdForA11y = false,
  children,
}: FieldViewWrapperProperties) => {
  const hasError = !isEmpty(errorMessage);
  const hasLabelHighlight = !isEmpty(labelClassName);
  return (
    <div
      className={cn(DEFAULT_WRAPPER_CLASS, toHide && "hidden", className)}
      style={style}
    >
      <Label
        htmlFor={labelUseIdForA11y ? undefined : id}
        id={labelUseIdForA11y ? `${id}-label` : undefined}
        variant="console"
        className={cn("mb-1 block", !hasLabelHighlight && "p-[3px]")}
      >
        {hasLabelHighlight ? (
          <span className={cn("inline-block p-[3px]", labelClassName)}>
            {startCase(label)}
          </span>
        ) : (
          startCase(label)
        )}
      </Label>
      {/* Guard: prevent parent font-weight/font-style from leaking into field content (e.g. editor looking bold when parent has font-bold). */}
      <div className="font-normal not-italic">{children}</div>
      {hasError && (
        <p id={`${id}-error`} className="mt-1 text-sm text-destructive">
          {errorMessage}
        </p>
      )}
    </div>
  );
};
